// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.App-logo {
    width: 200px;
    pointer-events: none;
}

html, body {
    margin: 0;
    padding: 0;
}

.containerMax {
    max-width: 1500px;
    margin: 0 auto; /* 가운데 정렬 */
}

.css-1uigekd-MuiCardContent-root:last-child {
    padding-bottom: 0 !important;
    padding: 5px;
}

.css-nxo287-MuiInputBase-input-MuiOutlinedInput-input {
    padding: 8.5px 14px !important;
}

/* 민원 화면전환 애니메이션*/

.fade-enter {
    opacity: 0;
}

.fade-enter-active {
    opacity: 1;
    transition: opacity 100ms ease-in-out;
}

.fade-exit {
    opacity: 1;
}

.fade-exit-active {
    opacity: 0;
    transition: opacity 100ms ease-in-out;
}
`, "",{"version":3,"sources":["webpack://./src/App.css"],"names":[],"mappings":"AAAA;IACI,YAAY;IACZ,oBAAoB;AACxB;;AAEA;IACI,SAAS;IACT,UAAU;AACd;;AAEA;IACI,iBAAiB;IACjB,cAAc,EAAE,WAAW;AAC/B;;AAEA;IACI,4BAA4B;IAC5B,YAAY;AAChB;;AAEA;IACI,8BAA8B;AAClC;;AAEA,iBAAiB;;AAEjB;IACI,UAAU;AACd;;AAEA;IACI,UAAU;IACV,qCAAqC;AACzC;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,UAAU;IACV,qCAAqC;AACzC","sourcesContent":[".App-logo {\r\n    width: 200px;\r\n    pointer-events: none;\r\n}\r\n\r\nhtml, body {\r\n    margin: 0;\r\n    padding: 0;\r\n}\r\n\r\n.containerMax {\r\n    max-width: 1500px;\r\n    margin: 0 auto; /* 가운데 정렬 */\r\n}\r\n\r\n.css-1uigekd-MuiCardContent-root:last-child {\r\n    padding-bottom: 0 !important;\r\n    padding: 5px;\r\n}\r\n\r\n.css-nxo287-MuiInputBase-input-MuiOutlinedInput-input {\r\n    padding: 8.5px 14px !important;\r\n}\r\n\r\n/* 민원 화면전환 애니메이션*/\r\n\r\n.fade-enter {\r\n    opacity: 0;\r\n}\r\n\r\n.fade-enter-active {\r\n    opacity: 1;\r\n    transition: opacity 100ms ease-in-out;\r\n}\r\n\r\n.fade-exit {\r\n    opacity: 1;\r\n}\r\n\r\n.fade-exit-active {\r\n    opacity: 0;\r\n    transition: opacity 100ms ease-in-out;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
